import React, { useState } from 'react';

import usePromoMeta from '../hooks/usePromoMeta';

import PromoByToggle, { type PromoByToggleSearch } from './PromoByToggle';
import PromoByToggleResults from './PromoByToggleResults';

export default function PromoByToggleTester() {
  const { promoMeta } = usePromoMeta();
  const [search, setSearch] = useState<PromoByToggleSearch>();

  return (
    <>
      <PromoByToggle promoMeta={promoMeta} onSearchChange={setSearch} />
      <PromoByToggleResults search={search} />
    </>
  );
}
